
const MyProduct = ({ item, handleClick, handleCheck }) => {
  const { name, serialnumber, url } = item;
  return (
    <div className="card has-text-centered">
        <div className="card-content">
            <figure className="image is-128x128 is-inline-block">
                <img src={url} alt="Image" />
            </figure>
            <p>{name.substring(0, 25)+"..."}</p>
            <p>Serial: {serialnumber}</p>
            <div className="is-inline-flex mt-1">
                <button className="button is-link mr-2" onClick={() => handleCheck(item)}>Check Contract</button>
            </div>
            
        </div>
    </div>
  );
};

export default MyProduct;